import { render, staticRenderFns } from "./kur_turu_ekle.vue?vue&type=template&id=f1bed314&scoped=true&"
import script from "./kur_turu_ekle.vue?vue&type=script&lang=js&"
export * from "./kur_turu_ekle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1bed314",
  null
  
)

export default component.exports